<template>
  <v-select
    class="search-select-item"
    v-model="filters.sizesSelected"
    item-text="name"
    item-value="size_code"
    :menu-props="{contentClass:'multi-select-search-menu', maxHeight: 'calc(100vh - 24px)'}"
    :label="$t('ARTWORK.SIZE')"
    :items="sizes"
    :loading="loading"
    clearable
    solo
    flat
    multiple
    hide-details
    return-object
    @click:clear="$emit('search')"
  >
    <template v-slot:selection="{ item, index }">
      <span v-if="index === 0">{{ $t('ARTWORK.SIZE') }}</span>
    </template>
  </v-select>
</template>

<script>
export default {
  props: ["filters", "sizes", "loading"],

  watch: {
    "filters.sizesSelected": {
      handler: function(val) {
        this.$emit("change");
      }
    }
  }
};
</script>
